import React from 'react';

import { makeClassNames } from '../../../utils/styles';

import './hr.scss';

const classNames = () =>
  makeClassNames({
    hr: 'hr',
  });

const cn = classNames();

const Hr = () => <hr className={cn.hr} />;

export default Hr;
